import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldInfoBySlugVariables = Types.Exact<{
  slug: Types.Scalars['String'];
}>;


export type ApiWorldInfoBySlug = { world: { curatorAddress: Address, id: number } | null };



export const ApiWorldInfoBySlugDocument = /*#__PURE__*/ `
    query WorldInfoBySlug($slug: String!) {
  world(slug: $slug) {
    curatorAddress
    id
  }
}
    `;

export const useWorldInfoBySlug = <
      TData = ApiWorldInfoBySlug,
      TError = ClientError
    >(
      variables: ApiWorldInfoBySlugVariables,
      options?: Omit<UseQueryOptions<ApiWorldInfoBySlug, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldInfoBySlug, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldInfoBySlug, TError, TData>(
      {
    queryKey: ['WorldInfoBySlug', variables],
    queryFn: apiFetcher<ApiWorldInfoBySlug, ApiWorldInfoBySlugVariables>(ApiWorldInfoBySlugDocument, variables),
    ...options
  }
    )};

useWorldInfoBySlug.getKey = (variables: ApiWorldInfoBySlugVariables) => ['WorldInfoBySlug', variables];

export const useInfiniteWorldInfoBySlug = <
      TData = InfiniteData<ApiWorldInfoBySlug>,
      TError = ClientError
    >(
      variables: ApiWorldInfoBySlugVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldInfoBySlug, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldInfoBySlug, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldInfoBySlug, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorldInfoBySlug.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldInfoBySlug, ApiWorldInfoBySlugVariables>(ApiWorldInfoBySlugDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldInfoBySlug.getKey = (variables: ApiWorldInfoBySlugVariables) => ['WorldInfoBySlug.infinite', variables];


useWorldInfoBySlug.fetcher = (variables: ApiWorldInfoBySlugVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldInfoBySlug, ApiWorldInfoBySlugVariables>(ApiWorldInfoBySlugDocument, variables, options);
